import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerUserService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetSystemUserStatusList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const getCustomerUserCustomerUserStatusList = useQuery(
    ['getCustomerUserCustomerUserStatusList'],
    async () => {
      return await handleRequest(
        CustomerUserService.getApiCustomerApiAppCustomerUserCustomerUserStatusList()
      );
    },
    {
      select: (data) => {
        const options = data?.map((item) => {
          return {
            label: item.status ?? '',
            value: item.statusId ?? '',
          };
        });

        const sortOptions = options?.concat({ label: 'All', value: 0 }).sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
        return sortOptions;
      },
    }
  );

  return getCustomerUserCustomerUserStatusList;
};

export default useGetSystemUserStatusList;
